import {JetView} from "webix-jet";

/**
 * AgeView class extends JetView to create a chart displaying user balances by age.
 */
export default class AgeView extends JetView {
	/**
	 * Configures the view layout and components.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for text translation
		return {
			type:"clean", // Clean layout type
			rows:[
				{ 
					template:_("Saldo Actual de usuarios por Edades"), // Header template with localized text
					type:"header", 
					css:"webix_header chart_header" // CSS class for styling the header
				},
				{
					view:"chart", // Chart component
					type:"scatter", // Scatter chart type
					localId:"chart", // Local ID for referencing the chart
					padding:{
						top:10, // Padding on top
						left:50, // Padding on left
						bottom:40 // Padding on bottom
					},
					/**
					 * Function to calculate the x-axis value based on the user's age.
					 * @param {Object} obj - The data object containing user information.
					 * @returns {number} The calculated age in years.
					 */
					xValue:obj => {
						return (new Date().getFullYear() - new Date(obj.age).getFullYear()); // Calculate age
					},
					value:"#money#", // Field to display on the y-axis
					item:{
						borderColor:"#fff", // Border color for chart items
						color:"#8664C6", // Fill color for chart items
						shadow:false, // Disable shadow for items
						radius:7, // Radius of chart items
						type:"d" // Type of chart item
					},
					xAxis:{
						start:22, // Starting point for x-axis
						step:4, // Step size for x-axis
						lines:false, // Disable grid lines
						color:"#EDEFF0", // Color of x-axis
						title:"Edad" // Title for x-axis
					},
					yAxis:{
						start:0, // Starting point for y-axis
						step:500, // Step size for y-axis
						color:"#fff", // Color of y-axis labels
						lineColor:"#EDEFF0", // Color of y-axis line
						title:"Saldo" // Title for y-axis
					},
					tooltip:{
						template:"<b>#user#</b><br>$#money#" // Tooltip template for displaying user balance
					}
				}
			]
		};
	}

	/**
	 * Initializes the view and sets up event listeners.
	 */
	init(){
		const cur_user = this.getParam("user", true); // Get current user parameter
		var vthis = this; // Preserve context for event handler
		this.on(this.app, "statisticsAgent:ageUsersStat", data => {
			vthis.$$("chart").clearAll(); // Clear existing chart data
			vthis.$$("chart").parse(data); // Parse new data into the chart
		});	
	}
}

// FILE DOCUMENTED
